let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}
// Set the cutoff date (Year, Month-1, Day, Hour, Minute, Second)
// var redirectDate = new Date(2026, 1, 1, 0, 0, 0); // Example: Feb 1, 2026

// var redirectURL = "https://www.instagram.com/jismik.store/";

// var now = new Date();

// if (now >= redirectDate) {
//   window.location.href = redirectURL;
// }
function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
